const getProductSumPrice = cartItems => 
    cartItems.reduce((a, c) => 
        c.product.offer_price ?
        a + Math.round(c.product.offer_price * c.qty * 100) / 100
        :
        a + Math.round(c.product.price * c.qty * 100) / 100
    , 0).toFixed(2)

export default getProductSumPrice;